// Path: src\Components\HtmlFreeGames\HtmlFreeGamesType.jsx
// Path: src\Components\HtmlFreeGames\HtmlFreeGamesType.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import BaseHome from "../Home/BaseHome";
import { useTranslation } from "react-i18next";
// import Games from "../../assets/images/games.svg";
import Game from "../../images/Game.png";

import { getHTMLGameListByCategory } from "../../api/htmlFreeGames";
import { toastError, toastSuccess } from "../../Utilities/toast";
import { kFormatter } from "../../Utilities/kFormatter";
import HtmlPopUp from "./HtmlPopUp";
import { base_apis, url } from "../../config/url";
import { useParams } from "react-router";
import ListLoader from "../Common/ListLoader";

const HtmlFreeGameType = () => {
  const { t } = useTranslation();
  const [HTMLGameList, setHTMLGameList] = useState([]);
  const [gameTypeId, setGameTypeId] = useState(null);
  const [htmlPopUp, setHtmlPopUp] = useState(false);
  const [htmlSelectGame, setHtmlSelectGame] = useState(null);
  const [htmlSelectGameType, setHtmlSelectGameType] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(12);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();

  useEffect(() => {
    if (currentPage <= totalPages) loadMore();
  }, [currentPage]);

  const loadMore = async () => {
    setLoading(true);
    fetchPacks();
  };

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchPacks = async () => {
    try {
      let data = {
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: "createdAt",
          sortDirection: "desc",
        },
        search: {
          html5Category: id,
        },
      };

      const res = await getHTMLGameListByCategory(data);
      setLoading(false);

      if (res?.success && res?.data) {
        if (currentPage == 1) {
          setHTMLGameList(res?.data);
        } else {
          setHTMLGameList([...HTMLGameList, ...res?.data]);
        }
        setTotalPages(res?.totalPages);
      } else {
        setHTMLGameList([]);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getFeatureImg = (data) => {
    return data ? `${base_apis?.imageUrl}${data}` : Game;
  };

  const joinPopup = (data) => {
    localStorage.setItem("activeFreeGameById", data?._id);
    setHtmlSelectGame(data);
    setHtmlPopUp(true);
  };

  return (
    <BaseHome title={localStorage?.getItem("activeFreeGame")}>
      {HTMLGameList && HTMLGameList?.length > 0 ? (
        <section className="mt-4 d-flex flex-wrap" style={{ gap: "1rem" }}>
          {HTMLGameList.map((freeGame, index) => {
            return (
              <div
                className="game-box game-html-box"
                style={{ height: "10rem" }}
                onClick={() => joinPopup(freeGame)}
                key={index}
                ref={
                  HTMLGameList?.length === index + 1 ? lastPostElementRef : null
                }
              >
                <div className="px-1 pb-1 text-center">
                  <span className="text-lower">
                    {" "}
                    {freeGame?.name?.length > 15 ? (
                          <marquee>{freeGame?.name}</marquee>
                        ) : (
                            freeGame?.name
                        )}
                    {/* <marquee>{freeGame?.name} </marquee> */}
                  </span>
                </div>
                <div className="home-game" style={{ height: "7rem" }}>
                  <div className="overlay">
                    <img src={url?.IMAGE_URL + freeGame?.thumbImage} />
                  </div>
                </div>
              </div>
            );
          })}
        </section>
      ) : (
        !loading && (
          <div className="w-100 d-flex justify-content-center">
            <span className="text-center">{t("common.no_data_found")}</span>
          </div>
        )
      )}
      {htmlPopUp && (
        <HtmlPopUp setHtmlPopUp={setHtmlPopUp} HtmlGameData={htmlSelectGame} />
      )}
      {loading && (
        <div className="w-100 d-flex justify-content-center">
          {" "}
          <ListLoader />
        </div>
      )}
    </BaseHome>
  );
};

export default HtmlFreeGameType;
